import { render } from "./PixelDrawer.vue?vue&type=template&id=c9f8db32&scoped=true"
import script from "./PixelDrawer.vue?vue&type=script&lang=js"
export * from "./PixelDrawer.vue?vue&type=script&lang=js"

import "./PixelDrawer.vue?vue&type=style&index=0&id=c9f8db32&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-c9f8db32"

export default script